import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.locale("zh-cn");

export function formatSquareMediaTime(seconds) {
	return dayjs.duration(Number(seconds) || 0, "seconds").format("mm:ss");
}

export function formatSquareDate(timestamp) {
	const now = dayjs();
	const targetDate = dayjs.unix(timestamp);
	const diffInDays = now.diff(targetDate, "day");

	if (diffInDays <= 3) {
		return targetDate.fromNow();
	}

	return targetDate.format("M月D日");
}
